import React from 'react'

import {
    Wrapper,
    Text,
    Link_scroll
} from './styled'

const BackBeginning = () => {

    return (
        <Wrapper>
            <Text>
                בתום העשור הראשון של המאה ה21 הזמר המזרחי הגיע כמעט אל הנחלה. היו עדיין טענות על קיפוח, חלקן מוצדקות, אך הז׳אנר על גווניו השונים צבע בצבעים עזים את הזרם המרכזי של התרבות הפופולרית בישראל. התהליך שהתחולל במשך השנים- מהקסטות שזכו לפופולריות גדולה בתחנה 
                המרכזית ולהתעלמות מוחלטת בתקשורת, דרך ״גטאות״ 
                של מוזיקה מזרחית ועד לפריצה של אייל גולן ושרית חדד 
                וההפיכה למיינסטרים- שינה את פניה של המוזיקה הזאת, 
                שממשיכה להשתנות ללא הרף מתקופה לתקופה.
            </Text>
            <Link_scroll
                to={'start'}
                smooth={true}
                duration={5000}
                spy={true}
                offset={-70}
            >
                לחזרה להתחלה
            </Link_scroll>
        </Wrapper>
    )
}

export default BackBeginning
